import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40521990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Arbeitsfläche Mast", -1))
const _hoisted_4 = { class: "content h-full max-h-full" }
const _hoisted_5 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Nutzungsarten der Fläche:", -1))
const _hoisted_12 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Fremdobjekte auf Fläche:", -1))
const _hoisted_14 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_15 = { class: "text-xs col-span-4 text-gray-500" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Analyse ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-6 border-solid rounded-md whiteYellowBorderColor" }, " Analyseergebnisse ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Fremdobjekte auf Fläche:", -1))
const _hoisted_19 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-lg md:text-lg" }, "Geländebeschaffenheit", -1))
const _hoisted_21 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ", -1))
const _hoisted_26 = { class: "text-xs text-gray-500" }
const _hoisted_27 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_28 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_29 = {
  class: "flex flex-col",
  style: {"height":"1000px"}
}
const _hoisted_30 = { class: "content" }
const _hoisted_31 = { class: "h-full max-h-full" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, " Geländebeschaffenheit - Fortsetzung ", -1))
const _hoisted_33 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_38 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_40 = { class: "text-xs text-gray-500" }
const _hoisted_41 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_43 = { class: "text-xs text-gray-500" }
const _hoisted_44 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_46 = { class: "text-xs text-gray-500" }
const _hoisted_47 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_48 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_49 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_51 = { class: "text-xs" }
const _hoisted_52 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_53 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_54 = {
  class: "flex flex-col",
  style: {"height":"1120px"}
}
const _hoisted_55 = { class: "content" }
const _hoisted_56 = { class: "h-full max-h-full" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, " Ökologie ", -1))
const _hoisted_58 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ampelkarte", -1))
const _hoisted_63 = { class: "col-span-5 text-xs" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "FFH-Gebiet", -1))
const _hoisted_65 = { class: "col-span-5 text-xs" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Biotop", -1))
const _hoisted_67 = { class: "text-xs col-span-5" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Vogelschutzgebiet", -1))
const _hoisted_69 = { class: "text-xs col-span-5" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Wasserschutzgebiet", -1))
const _hoisted_71 = { class: "text-xs col-span-5" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Sonstiges", -1))
const _hoisted_73 = { class: "text-xs col-span-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_bauflaechen_footer = _resolveComponent("bauflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_pdf_a_4_page = _resolveComponent("pdf-a-4-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-der-flaeche'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", {
                      key: key,
                      class: ""
                    }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v), 1))
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.nutzungsart-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.weitere-fremdobjekte-auf-flaeche'
                )['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.sonstiges-vorhanden",
                  label: "Sonstiges",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.sonstiges-beschreibung'
                )['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.sonstiges-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end col-span-2"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.allgemein-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _hoisted_16,
                _hoisted_17,
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.allgemeine-punkte-group.fremdobjekte-auf-flaeche'
                )['eingabeText']), 1)
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _createVNode(_component_is_vorhanden_char_and_label, {
                  ba: _ctx.ba,
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-vorhanden",
                  label: "Gefälle/Hang/Böschung",
                  class: "col-span-2"
                }, null, 8, ["ba"]),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-boeschung-art'
                )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                    return (_openBlock(), _createElementBlock("ul", { key: key }, [
                      (_openBlock(), _createElementBlock("li", {
                        key: key,
                        class: "text-xs text-gray-500"
                      }, _toDisplayString(v), 1))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-beschreibung'
                )['eingabeText']), 1),
                _createVNode(_component_bewertung_chip, {
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bewertung",
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  lang: _ctx.lang,
                  class: "justify-self-end"
                }, null, 8, ["ba", "immobilie", "lang"]),
                _createVNode(_component_oneto_five_image_div, {
                  ba: _ctx.ba,
                  immobilie: _ctx.immobilie,
                  fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.gefaelle-group.gefaelle-bilder",
                  lang: _ctx.lang,
                  class: "col-span-8 ml-2"
                }, null, 8, ["ba", "immobilie", "lang"])
              ])
            ]),
            _createVNode(_component_bauflaechen_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a_4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35,
                  _hoisted_36,
                  _hoisted_37,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-erforderlich",
                    label: "Ausholzung erforderlich",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-beschreibung'
                  )['eingabeText']), 1),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-art'
                  )['eingabeMehrfachAuswahlWerts'], (v, key) => {
                      return (_openBlock(), _createElementBlock("ul", { key: key }, [
                        (_openBlock(), _createElementBlock("li", {
                          key: key,
                          class: "text-xs text-gray-500"
                        }, _toDisplayString(v), 1))
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.ausholzung-group.ausholzung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-erforderlich",
                    label: "Rodung erforderlich",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-beschreibung'
                  )['eingabeText']), 1),
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-anzahl-baeume'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.graben-group.graben-vorhanden",
                    label: "Graben vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.graben-group.graben-beschreibung'
                  )['eingabeText']), 1),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.graben-group.graben-anzahl'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.graben-group.graben-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-vorhanden",
                    label: "Feuchtgebiete vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-beschreibung'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "col-span-3 justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.feuchtgebiete-group.feuchtgebiete-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                    label: "Naturdenkmäler vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-beschreibung'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "col-span-3 justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.naturdenkmaeler-group.naturdenkmaeler-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-vorhanden",
                    label: "Kampfmittel vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-beschreibung'
                  )['eingabeText']), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-freimessung",
                    label: "freimessen",
                    class: "col-span-1"
                  }, null, 8, ["ba"]),
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-art'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.kampfmittel-group.kampfmittel-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    ba: _ctx.ba,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-vorhanden",
                    label: "Sonstiges vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["ba"]),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-beschreibung'
                  )['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div, {
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.sonstiges-group.sonstiges-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8"
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ])
          ]),
          _createVNode(_component_bauflaechen_footer, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang
          }, null, 8, ["ba", "immobilie", "lang"])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"]),
    _createVNode(_component_pdf_a_4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _hoisted_60,
                  _hoisted_61,
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.ampelkarte'
                )?.getCurrentInput()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.ampelkarte-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.useIdentifierFrageFinder(
                  _ctx.ba,
                  'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.ffh-gebiet'
                )['eingabeAuswahlWert']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.ffh-gebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.biotop'
                  )['eingabeAuswahlWert']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.biotop-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_68,
                  _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.vogelschutzgebiet'
                  )['eingabeAuswahlWert']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.vogelschutzgebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_70,
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.wasserschutzgebiet'
                  )['eingabeAuswahlWert']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.wasserschutzgebiet-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"]),
                  _hoisted_72,
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.useIdentifierFrageFinder(
                    _ctx.ba,
                    'rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.sonstiges'
                  )['eingabeAuswahlWert']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragesPath: "rippistein-bauflaechen.arbeitsflaeche-mast-tab.oekologie-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["ba", "immobilie", "lang"])
                ])
              ])
            ]),
            _createVNode(_component_bauflaechen_footer, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"])
  ], 64))
}